import { User } from 'apprise-core/user';
import { useOracle } from 'apprise-frontend-iam/authz/oracle';
import { useTenantOracle } from 'apprise-frontend-iam/tenant/oracle';


export const useUserOracle = () => {

    const tenancy = useOracle()
    const tenants = useTenantOracle()
   
    const self = {

        canEdit: (user: User) => tenants.canEdit(user?.tenant) 

        ,

       
        canAdd: () => tenants.canAdd() || tenancy.isTenantManager()


        ,

        canRemove: (user: User) => user.lifecycle.state === 'inactive'


    }


    return self
}

